import { createI18n, type MessageContext } from 'vue-i18n'
import { locales, loadLocale } from '@/utils/locale'
import baseTranslations from '@/translations.json'
import { localTranslations } from './localTranslations'
// import productMemos from '@/product_memos.json'
import { isProduction } from '@/utils/environment'

export function formatString(message: string, obj: Record<string, unknown>) {
  // This regex detects i18n-like insertions: "The price is {price} euros"
  const formatRegex = /\{([0-9a-zA-Z]+)\}/g

  return message.replace(formatRegex, (raw, field) => String(obj[field] ?? raw))
}

type Translations = {
  [key in 'de' | 'en' | 'fr' | 'nl' | 'debug']?: Record<string, string | null>
}

export const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  allowComposition: true,
  locale: loadLocale(),
  availableLocales: locales,
  messageCompiler: (message: string) => (ctx: MessageContext) =>
    formatString(message, ctx.values),
  ...(isProduction()
    ? {
        fallbackLocale: 'de',
      }
    : {
        missingWarn: true,
      }),
})

const translationFiles = [baseTranslations]

export function applyLocalTranslations() {
  locales.forEach((locale) => {
    i18n.global.mergeLocaleMessage(
      locale,
      localTranslations[locale as keyof typeof localTranslations] ?? {}
    )
  })
}

translationFiles.forEach((translationsFile) => {
  const typedFile = translationsFile as Translations

  locales.forEach((locale) => {
    const messages = {
      ...(typedFile[locale] ?? {}),
      ...(localTranslations[locale as keyof typeof localTranslations] ?? {}),
    }
    i18n.global.mergeLocaleMessage(locale, messages)
  })
})
